import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustompageService } from '../../../../../services/api-store/custompage/custompage.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { HttpErrorResponse } from '@angular/common/http';
import { CustompageRequest, CustompageTemplate } from '../../../../../models/api-store/custompage/custompage.request.model';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-custompage-create',
  templateUrl: './custompage-create.component.html',
  styleUrls: ['./custompage-create.component.css']
})
export class CustompageCreateComponent {

  formBuilder: FormGroup;
  request: any = {};
  isButtonSaveDisabled: boolean;
  template: string = 'clean';

  constructor(
    private custompageService: CustompageService,
    private fb: FormBuilder,
    private toastr: ToastrService,
    private spinner: SpinnerService,
    public activeModal: NgbActiveModal,
  ) {
    this.initForm();
  }

  get form() { return this.formBuilder; }
  get formControls() { return this.formBuilder.controls; }


  initForm() {
    this.formBuilder = this.fb.group({
      title: ["", Validators.required],
    });
    this.isButtonSaveDisabled = false;
  }


  getValue() {
    let request = new CustompageRequest();
    request.title = this.formBuilder.controls['title'].value;
    request.seoId = this.formBuilder.controls['title'].value;
    if (this.template == 'clean') {
      request.template = CustompageTemplate.CLEAN;
    } else if (this.template == 'map') {
      request.template = CustompageTemplate.MAP;
    }
    return request;
  }

  save() {
    this.request = this.getValue();
    this.custompageService.create(this.request).subscribe(
      (response) => {
        if (response) {
          //Salvato
          this.toastr.success('Pagina Custom creata con successo', 'Crea Pagina Custom', {
            timeOut: 5000
          });
          this.activeModal.close(response);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        console.log(error);
        this.toastr.error('Si è verificato un errore durante la creazione della Pagina Custom', 'Crea Pagina Custom', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  /**
   * Azione click su button salva modifiche
   */
  clickButtonSave() {
    if (this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE) {
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  /**
   * Azione click su button Annulla
   */
  clickButtonCancel() {
    //Torna indietro alla tabella
    this.activeModal.close('CLOSE');
  }
}
